import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import CheckSvg from 'assets/svgr-icons/Check.svg'

export const CheckIcon = styled(CheckSvg)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  path {
    fill: ${COLORS.primaryDark};
  }
`
export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const OptionRow = styled.button<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 36px;
  padding: 0 8px;
  border: none;
  border-radius: 6px;
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryExtraLight : 'transparent'};
  cursor: pointer;
  transition: background-color 0.15s ease;
  text-align: left;

  &:hover {
    background-color: ${COLORS.primaryExtraLight};
  }
`

export const OptionIconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;

    path {
      fill: ${COLORS.secondaryDark};
    }
  }
`

export const OptionLabel = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: ${COLORS.secondaryDark};
`
